<template>
  <panel :heading="label">
    <span v-if="content">{{ content }}</span>
    <span v-else>Welcome to {{ $store.getters['app/appName'] }}!</span>
  </panel>
</template>

<script>
import Panel from '@components/singletons/panel';

export default {
  components: { Panel },
  props: {
    label: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
};
</script>